import {ROUTES} from '../../../../_gori/constants'

export const HELP_CENTER_WIDGET_ROUTE_BLACKLIST = [
  ROUTES.LANDING.BASE,
  ...Object.values(ROUTES.AUTH),
]
